export enum TransferEncoding {
    Base64,
    Text,
}
